import useLocalData from '../useLocalData';

const useFileData = () => {
    const csvFileData = useLocalData('fileData');
    return csvFileData || [];
};

export default useFileData;
